export default {
    users : [],
    segmentType : [],
    segment : [],
    types : [],
    getSegments : [],
    newEntity : [],
    oneSegment : {},
    deleteAudience : {},
    updateDetail : {},
    updateOneAudience: {},
}